import { Link } from 'react-router-dom'
import toast from 'react-hot-toast'
import { ArticleTag } from '../../HomePage/ArticleTag'
import {
  articelsHomePageImages,
  images,
} from '../../../services/images.service'
import { Button, GreyBorderBottom, GreyDivider } from '../../ui/elements'
import { Knife, Mask } from '../../ui/icons/post'

export function PostSidebarInfo({
  post,
  author,
  postCount,
  loggedInUser,
  onEdit,
  onRemove,
}) {
  if (!post) return null

  return (
    <aside
      className="hidden lg:block mt-6 w-[350px]"
      role="complementary"
      aria-label="מידע נוסף על הפוסט"
    >
      {/* Breadcrumbs */}
      <nav
        className="mb-6 text-sm text-softText"
        aria-label="ניווט משני – מיקום בדף"
      >
        <ol className="flex items-center gap-4 text-h6">
          <li>
            <Link
              to="/"
              className="hover:underline"
              aria-label="מעבר לדף הבית"
              title="בית"
            >
              <span>בית</span>
            </Link>
          </li>
          <img
            src={articelsHomePageImages.arrowIcon}
            alt=""
            aria-hidden="true"
          />
          <li>
            <Link
              to="/posts"
              className="hover:underline"
              aria-label="מעבר לרשימת הפוסטים"
              title="פוסטים"
            >
              <span>פוסטים</span>
            </Link>
          </li>
          <img
            src={articelsHomePageImages.arrowIcon}
            alt=""
            aria-hidden="true"
          />
          <li>
            <Link
              to={`/post/${post._id}`}
              className="hover:underline line-clamp-1"
              aria-label={`מעבר לפוסט "${post.title}"`}
              title={post.title}
            >
              {post.title}
            </Link>
          </li>
        </ol>
      </nav>

      {/* Divider with Tags */}
      <div className="relative" aria-label="תגיות הפוסט">
        <GreyDivider />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
          <ArticleTag tags={post.tags} />
        </div>
      </div>

      {/* Author Info */}
      {author && (
        <div className="flex items-center justify-between mt-6">
          <div className="flex gap-2 items-center">
            <img
              className="w-16 h-16 rounded-full"
              src={author.image}
              alt={`תמונת פרופיל של ${author.nickname}`}
            />
            <div>
              <Link
                to={`/user/${author.username}`}
                aria-label={`מעבר לפרופיל של ${author.nickname}`}
                title={author.nickname}
              >
                <h5 className="text-h5">{author.nickname}</h5>
              </Link>
              <h6
                className="text-h6 text-muted"
                aria-label={`מספר כתבות: ${postCount}`}
              >
                {postCount} כתבות
              </h6>
            </div>
          </div>
          <img
            src="https://res.cloudinary.com/drejchdwh/image/upload/v1732629076/unselected-watchlist_vg0jty.svg"
            alt="הוסף למועדפים"
            title="הוסף למועדפים"
          />
        </div>
      )}

      {/* Linked Anime */}
      <div className="mt-6">
        {post.linkedAnime ? (
          <Link
            to={`/anime/${post.linkedAnime}`}
            className="flex justify-between w-full items-center"
            aria-label="מעבר לדף האנימה המקושר"
            title="מידע נוסף על האנימה"
          >
            <span className="text-buttonSecondary1">מידע נוסף על האנימה</span>
            <img
              src={articelsHomePageImages.moreInfoIcon}
              alt=""
              aria-hidden="true"
            />
          </Link>
        ) : (
          <button
            className="flex justify-between w-full items-center cursor-not-allowed"
            onClick={() => toast.error('לא נמצא אנימה זו')}
            aria-disabled="true"
            aria-label="לא נמצא אנימה מקושרת"
            title="מידע נוסף על האנימה"
          >
            <span className="text-buttonSecondary1">מידע נוסף על האנימה</span>
            <img
              src={articelsHomePageImages.moreInfoIcon}
              alt=""
              aria-hidden="true"
            />
          </button>
        )}
      </div>

      <GreyDivider className="my-6" />

      {/* Edit / Delete buttons */}
      {loggedInUser?.role === 'admin' || loggedInUser?.role === 'editor' ? (
        <>
          <Button
            text="ערוך כתבה"
            width={340}
            height={60}
            onClick={onEdit}
            fontSize="text-lg"
            textColor="text-buttonSecondary1"
            bgColor="fill-accentLight"
            hoverBgColor="hover:scale-105 transform duration-300"
            aria-label="ערוך את הכתבה הנוכחית"
            title="ערוך כתבה"
          />

          <Button
            text="הסר כתבה"
            width={340}
            height={60}
            onClick={() => onRemove(post._id)}
            fontSize="text-lg"
            textColor="text-buttonSecondary1"
            bgColor="fill-accentLight"
            hoverBgColor="hover:scale-105 transform duration-300"
            aria-label="מחק את הכתבה הנוכחית"
            title="הסר כתבה"
          />
        </>
      ) : null}

      <a
        href="https://discord.gg/uGpcw4ayCr"
        target="_blank"
        rel="noopener noreferrer"
        className="block my-10"
        aria-label="הצטרפו לשרת הדיסקורד של AniZone בקישור חיצוני"
        title="הצטרפו לשרת הדיסקורד של AniZone"
      >
        <img
          src="https://pub-60946b28fb374ff48942bac3163dd658.r2.dev/uploads/2025/05/banner-1747133620065.webp"
          alt="באנר הזמנה לשרת הדיסקורד של AniZone"
          title="הצטרפו עכשיו לשרת הדיסקורד של AniZone"
          className="w-full h-auto"
        />
      </a>

      {/* Links to other sections */}
      <div className="mt-10 flex flex-col gap-6">
        <div>
          <h5>עוד באתר</h5>
          <GreyBorderBottom className="w-full" />
        </div>
        <Link
          to="/anime-glossary"
          aria-label="מעבר לעמוד מילון מושגים"
          title="מילון מושגים"
        >
          <div
            style={{
              borderImage: `url(${images.redBorder}) 10 stretch`,
              borderWidth: '2px',
              borderStyle: 'solid',
            }}
            className="relative w-full h-[180px] cursor-pointer"
          >
            <div
              className="absolute inset-0 bg-cover bg-center"
              style={{ backgroundImage: `url(${images.redBorder})` }}
            />
            <div className="absolute inset-0 bg-background opacity-85" />
            <div className="relative z-10 flex flex-col items-center justify-center h-full">
              <Knife />
              <h3 className="text-h3">מילון מושגים</h3>
            </div>
          </div>
        </Link>

        <Link
          to="/japan-trip"
          aria-label="מעבר לעמוד המסע ליפן"
          title="המסע ליפן"
        >
          <div
            style={{
              borderImage: `url(${images.redBorder}) 10 stretch`,
              borderWidth: '2px',
              borderStyle: 'solid',
            }}
            className="relative w-full h-[180px] cursor-pointer"
          >
            <div
              className="absolute inset-0 bg-cover bg-center"
              style={{ backgroundImage: `url(${images.redBorder})` }}
            />
            <div className="absolute inset-0 bg-background opacity-85" />
            <div className="relative z-10 flex flex-col items-center justify-center h-full">
              <Mask />
              <h3 className="text-h3">המסע ליפן</h3>
            </div>
          </div>
        </Link>
      </div>
    </aside>
  )
}
